export const DATA_ADDED = "Invite sent successfully!";
export const JOINED = "JOINED";
export const INVITED = "INVITED";
export const INFO_TOOLTIP =
  "This is your foreign subsidiary/parent entity accountant. An subsidiary/parent entity accountant can only access the Form 5471 filing";

export const NO_SERVICE_TEAM_UUID = "NO_SERVICE_TEAM_UUID";
export const NO_SERVICE_TEAM_NAME = "**No team Assigned**";
